module.exports = __webpack_public_path__ + "static/media/Slide12.c6e6cda8.jpg";